import { render } from "./TrailerForm.vue?vue&type=template&id=35fa9d3e&scoped=true"
import script from "./TrailerForm.vue?vue&type=script&lang=js"
export * from "./TrailerForm.vue?vue&type=script&lang=js"

import "./TrailerForm.vue?vue&type=style&index=0&id=35fa9d3e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fa9d3e"]])

export default __exports__